import { TFunction } from 'react-i18next';

import { MirrorService } from 'services/MirrorService';
import { PackageProductSubtype } from 'types/enums/PackageProductSubtype';
import { Package } from 'types/interfaces/Package';

import {
  getSessionStorageItem,
  setSessionStorageItem,
} from 'helpers/sessionStorage';
import { assertStringArray } from 'helpers/utils/checkType';

const SELECTED_UPSALES_KEY = 'ups';

export const saveUpsalesIdsToSessionStorage = (ids: string[]) => {
  setSessionStorageItem(SELECTED_UPSALES_KEY, JSON.stringify(ids));
};

export const getSelectedUpsalesIdsFromSessionStorage = () => {
  const raw = getSessionStorageItem(SELECTED_UPSALES_KEY);

  if (!raw) {
    return null;
  }

  const parsed = JSON.parse(raw);

  return assertStringArray(parsed) ? parsed : null;
};

export const updateSelectedUpsales = (upsalePackId: string) => {
  const upsalesIds = getSelectedUpsalesIdsFromSessionStorage();

  if (!upsalesIds) {
    saveUpsalesIdsToSessionStorage([upsalePackId]);

    return;
  }

  saveUpsalesIdsToSessionStorage(
    upsalesIds.includes(upsalePackId)
      ? upsalesIds.filter((id) => id !== upsalePackId)
      : [...upsalesIds, upsalePackId]
  );
};

export const getUpsalePackageDescription = (
  t: TFunction,
  upsalePackage: Package,
  creditsCurrency: string,
  recurringInitialPrice: string | undefined,
  isCreditOptimizationSplit: boolean
) => {
  if (upsalePackage.product_subtype === PackageProductSubtype.CreditUpsale) {
    return t('payment.upsaleDescriptionTypeOptimizedCredits', {
      credits: creditsCurrency,
      creditsBuy: upsalePackage.recurring_credits_buy,
      freeCreditCount: isCreditOptimizationSplit ? 10 : 100,
      recurringInitial:
        MirrorService.groupId === 2
          ? upsalePackage.recurring_price_full_text
          : recurringInitialPrice,
      supportEmail: MirrorService.supportEmail,
      initDuration:
        MirrorService.groupId === 2
          ? upsalePackage.duration_init_text
          : upsalePackage.duration_init,
    });
  }

  return t('payment.upsaleDescription', {
    initDuration: upsalePackage.duration_init,
    initDurationText: upsalePackage.duration_init_text,
    packageName: upsalePackage.display_name,
    recurringInitial: recurringInitialPrice,
  });
};
